import { RegisterTypeComponent } from '../../components/RegisterSystem/RegisterTypeComponent';
import { Footer } from "../../components/share/Footer";
// import { NavMenu } from "../../components/NavMenu";
import { HeadTitle } from "../../components/share/HeadTitle";
import { NavbarIndexComponent } from "../../components/share/NavbarIndexComponent";

export function RegisterTypeContainer() {
    const titleName = "ลงทะเบียนเข้าใช้งาน";
    return (
        <div className="page-container bg-landing">
            {/* <NavMenu /> */}
            <NavbarIndexComponent />
            <HeadTitle title={titleName} />
            <RegisterTypeComponent />
            <Footer />
        </div>
    );
}
